import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule, isDevMode, InjectionToken } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule, SwPush, SwUpdate } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MomentModule } from 'ngx-moment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from './modules/core/core.module';

import trLocale from '@angular/common/locales/tr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { ServiceInterceptor } from './modules/core/services/service.interceptor';
//import { PushNotificationService, SW_PUSH, SW_UPDATE } from './modules/core/services/push-notification.service';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(trLocale);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    MomentModule,
    CoreModule,
  /*  ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),*/
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      defaultLanguage: 'en'
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "en-US" },
    { provide: HTTP_INTERCEPTORS, useClass: ServiceInterceptor, multi: true },
    { provide: NZ_I18N, useValue: en_US },
  //  { provide: SW_PUSH, useClass: SwPush },
  //  { provide: SW_UPDATE, useClass: SwUpdate },
  //  PushNotificationService,
    SwPush,
    SwUpdate
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
